export default "__VITE_ASSET__78oyiYpF__"